var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "system_drawer_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v("说明：每个页面只能有一个" + _vm._s(_vm.value.widget)),
      ]),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "header_title" }, [_vm._v("样式")]),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-form-item",
              {
                staticClass: "style_wrap",
                attrs: {
                  prop: "show_style",
                  rules: [
                    {
                      required: true,
                      message: "请选择样式",
                      trigger: "change",
                    },
                  ],
                },
              },
              _vm._l(_vm.value.config_default_value.style, function (img) {
                return _c("el-image", {
                  key: img.id,
                  class: [
                    "show_style",
                    img.id === _vm.value.config.show_style && "active",
                  ],
                  attrs: { src: img.imageurl },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      !_vm.parentKey
        ? _c("div", { staticClass: "box bg_box" }, [
            _c("div", { staticClass: "header_title" }, [
              _c("span", [_vm._v(" 抽屉图标 ")]),
            ]),
            _c(
              "div",
              { staticClass: "content value" },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "upload-box",
                    attrs: {
                      prop: "imageurl",
                      rules: [
                        {
                          required: true,
                          message: "图标不可为空",
                          trigger: "change",
                        },
                      ],
                      "label-width": "5rem",
                      label: "图标",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "upload" },
                      [
                        _c("upload-file", {
                          ref: "uploadIcon",
                          attrs: {
                            "link-url": _vm.linkUrl,
                            tempurl: _vm.value.config.imageurl,
                            uploadInfo: _vm.uploadInfo,
                          },
                          on: {
                            emitUploadFile: function (res) {
                              return _vm.emitUploadFile(res, _vm.value.config)
                            },
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "upload-item-wrap" },
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onUpload("uploadIcon")
                                  },
                                },
                              },
                              [_vm._v(" 上传图片 ")]
                            ),
                            _vm.pictureList.length > 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectPicture()
                                      },
                                    },
                                  },
                                  [_vm._v(" 选择图片 ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "tips" }, [
                      _vm._v(
                        " 建议尺寸为60X60px，支持png格式图片，大小不超过2M "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c("div", { key: index, staticClass: "box bg_box move" }, [
            _c(
              "div",
              { staticClass: "header_title" },
              [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        item.type === "switch_account" ? "切换企业" : "新增菜单"
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "value." + index + ".flag",
                      rules: [
                        {
                          required: true,
                          validator: function (rule, value, callback) {
                            return _vm.checkFlag(rule, value, callback)
                          },
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flag" },
                      [
                        _vm.showDelete && item.type !== "switch_account"
                          ? _c("i", {
                              staticClass: "el-icon el-icon-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.onDelete(index)
                                },
                              },
                            })
                          : _vm._e(),
                        _c("el-switch", {
                          attrs: {
                            "active-value": true,
                            "inactive-value": false,
                          },
                          model: {
                            value: item.flag,
                            callback: function ($$v) {
                              _vm.$set(item, "flag", $$v)
                            },
                            expression: "item.flag",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "content value" },
              [
                item.flag
                  ? [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "value." + index + ".name",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "展示文案不可为空",
                              },
                            ],
                            "label-width": "5rem",
                            label: "展示文案",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入",
                              maxlength: "5",
                              "show-word-limit": "",
                              clearable: "",
                            },
                            model: {
                              value: item.name,
                              callback: function ($$v) {
                                _vm.$set(item, "name", $$v)
                              },
                              expression: "item.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "upload-box",
                          attrs: {
                            prop: "value." + index + ".imageurl",
                            rules: [
                              {
                                required: true,
                                message: "图标不可为空",
                                trigger: "change",
                              },
                            ],
                            "label-width": "5rem",
                            label: "图标",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "upload" },
                            [
                              _c("upload-file", {
                                ref: "uploadBanner",
                                refInFor: true,
                                attrs: {
                                  "link-url": _vm.linkUrl,
                                  tempurl: item.imageurl,
                                  uploadInfo: _vm.uploadInfo,
                                },
                                on: {
                                  emitUploadFile: function (res) {
                                    return _vm.emitUploadFile(res, item)
                                  },
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "upload-item-wrap" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUpload(index)
                                        },
                                      },
                                    },
                                    [_vm._v(" 上传图片 ")]
                                  ),
                                  _vm.pictureList.length > 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectPicture(index)
                                            },
                                          },
                                        },
                                        [_vm._v(" 选择图片 ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(
                              " 建议尺寸为60X60px，支持png格式图片，大小不超过2M "
                            ),
                          ]),
                        ]
                      ),
                      item.type === "switch_account"
                        ? _c(
                            "div",
                            [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("企业排列顺序"),
                              ]),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "value." + index + ".account_sort",
                                    rules: [
                                      {
                                        required: true,
                                        message: "请选择排列顺序",
                                        trigger: "change",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: item.account_sort,
                                        callback: function ($$v) {
                                          _vm.$set(item, "account_sort", $$v)
                                        },
                                        expression: "item.account_sort",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("默认排序"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("先加入或发卡的企业靠前展示"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              staticClass: "config-menu",
                              attrs: {
                                label: "跳转功能",
                                "label-width": "5rem",
                                required: "",
                              },
                            },
                            [
                              _c("config-menu", {
                                key: item.uid,
                                attrs: {
                                  value: item,
                                  type: _vm.value.key,
                                  index: index,
                                  info: _vm.info,
                                  menuList: _vm.menuList,
                                  childrenMenuList: _vm.childrenMenuList,
                                  customerModuleList: _vm.customerModuleList,
                                  eBookCategoryList: _vm.eBookCategoryList,
                                  aBookCategoryList: _vm.aBookCategoryList,
                                  customerPackageList: _vm.customerPackageList,
                                  systemMenus: _vm.systemMenus,
                                },
                              }),
                            ],
                            1
                          ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        }),
        0
      ),
      _c(
        "el-button",
        {
          staticClass: "add",
          attrs: { type: "primary", icon: "el-icon-plus" },
          on: { click: _vm.addMenu },
        },
        [_vm._v(" 添加分类 ")]
      ),
      _c("div", { staticClass: "tips" }, [
        _vm._v(
          " 上下切换菜单模块可调整顺序（调整顺序内容：新增菜单+切换企业） "
        ),
      ]),
      !_vm.parentKey
        ? [
            _c(
              "el-form-item",
              {
                staticClass: "margin_top",
                attrs: {
                  prop: "margin_top",
                  rules: [{ type: "number", message: "间距必须为数字值" }],
                },
              },
              [
                _c("div", [_vm._v("与上方组件的间距")]),
                _c("el-input", {
                  attrs: { placeholder: "请输入间距", clearable: "" },
                  model: {
                    value: _vm.value.config.margin_top,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
                    },
                    expression: "value.config.margin_top",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "z_index",
                attrs: {
                  prop: "z_index",
                  rules: [
                    {
                      required: true,
                      pattern: /^(?:[1-9]|[1-9][0-9])$/,
                      message: "请输入1-99之间的整数！",
                    },
                  ],
                },
              },
              [
                _c("div", [_vm._v("层级高度值")]),
                _c("el-input", {
                  attrs: { placeholder: "请输入层级高度值", clearable: "" },
                  model: {
                    value: _vm.value.config.z_index,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
                    },
                    expression: "value.config.z_index",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }